var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotSubmitted = function SvgNotSubmitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Error - Free interface icons-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9306",
    d: "M16.771 43.75H5.208A5.213 5.213 0 0 1 0 38.542V5.208A5.213 5.213 0 0 1 5.208 0h25a5.213 5.213 0 0 1 5.208 5.208v14.646a1.042 1.042 0 1 1-2.083 0V5.208a3.129 3.129 0 0 0-3.125-3.125h-25a3.129 3.129 0 0 0-3.125 3.125v33.334a3.129 3.129 0 0 0 3.125 3.125h11.563a1.042 1.042 0 0 1 0 2.083Z",
    fill: "#26890d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9307",
    d: "M28.125 18.75H7.292a1.042 1.042 0 0 1 0-2.083h20.833a1.042 1.042 0 1 1 0 2.083Z",
    fill: "#26890d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9308",
    d: "M19.792 27.083h-12.5a1.042 1.042 0 1 1 0-2.083h12.5a1.042 1.042 0 0 1 0 2.083Z",
    fill: "#26890d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9309",
    d: "M17.708 10.416H7.292a1.042 1.042 0 1 1 0-2.083h10.416a1.042 1.042 0 1 1 0 2.083Z",
    fill: "#26890d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9310",
    d: "M46.875 50H23.958a3.129 3.129 0 0 1-3.125-3.125 2.969 2.969 0 0 1 .49-1.665L32.756 26.5a3.108 3.108 0 0 1 5.329.017L49.533 45.25A2.911 2.911 0 0 1 50 46.875 3.129 3.129 0 0 1 46.875 50ZM35.416 27.083a1.008 1.008 0 0 0-.871.485L23.077 46.335a.925.925 0 0 0-.16.54 1.045 1.045 0 0 0 1.042 1.042h22.916a1.045 1.045 0 0 0 1.042-1.042.882.882 0 0 0-.135-.5l-11.484-18.79a1.018 1.018 0 0 0-.881-.5Z",
    fill: "#26890d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9311",
    d: "M35.417 41.667a1.042 1.042 0 0 1-1.042-1.042v-8.333a1.042 1.042 0 1 1 2.083 0v8.333a1.042 1.042 0 0 1-1.041 1.042Z",
    fill: "#26890d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 23",
    cx: 1.042,
    cy: 1.042,
    r: 1.042,
    transform: "translate(34.375 43.75)",
    fill: "#26890d"
  })));
};
export default SvgNotSubmitted;